import React, { useState } from 'react'
import './Foooter.scss'

import { Link } from 'react-router-dom'

import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/navigation'

import { Autoplay } from 'swiper/modules'

import locationIcon from '../../assets/Pictures/Location.svg'
import tellIcon from '../../assets/Pictures/tell.svg'
import emailIcon from '../../assets/Pictures/mail.svg'
import arrowIcon from '../../assets/Pictures/arrowContactus.svg'

import instagram from '../../assets/Pictures/instagram.svg'
import telegram from '../../assets/Pictures/telegram.svg'
import whatsapp from '../../assets/Pictures/whatsapp.svg'
import twitter from '../../assets/Pictures/twiiter.svg'
import facebook from '../../assets/Pictures/facebook.svg'

import vigorLogo from '../../assets/Pictures/logoVigor.svg'
import energyLogo from '../../assets/Pictures/logoEnergy.svg'

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export default function Footer() {
  const [email, setEmail] = useState('')

  const emailHandler = () => {
    if (email.length > 5 && email.includes('@')) {
      toast.success('thank you for join', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    } else {
      toast.error('email address wrong', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='footer'>
        <div className='container'>
          <div className='menu'>
            <div className='title'>
              Main Menu
            </div>
            <ul>
              <li>
                <Link to='/corperate'>corporate</Link>
              </li>
              <li>
                <Link to='/products'>products</Link>
              </li>
              <li>
                <Link to='/e-catalog'>e-catalog</Link>
              </li>
              <li>
                <Link to='/contact'>contact</Link>
              </li>
            </ul>
          </div>
          <div className='menu'>
            <div className='title'>
              Contact Us
            </div>
            <Swiper 
              speed={1800}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }} navigation={true} modules={[Autoplay]} className='mySwiper'>
              <SwiperSlide>
                <ul className='contactDetail'>
                  <li className='address'>
                    <img src={locationIcon} alt='locationIcon' />
                      Maltepe Mah, Eski Cirpici Yolu sk. No: 3B IC 
                      Kapi No:
                      48 Zeytinburnu/ Istanbul . Turkey
                  </li>
                  <li>
                    <img src={tellIcon} alt='tellIcon' />
                    +90 539 938 8835
                  </li>
                  <li>
                    <img src={emailIcon} alt='emailIcon' />
                    info@globalenergyinvestmentco.com
                  </li>
                  <li>
                    <img src={arrowIcon} alt='arrowIcon' />
                    other branch
                  </li>
                </ul>
              </SwiperSlide>
              <SwiperSlide>
              <ul className='contactDetail'>
                  <li className='address'>
                    <img src={locationIcon} alt='locationIcon' />
                    No.44, Building 533, AL Maha St, AL khuwair, Muscat
                    Sultanate of OMAN
                  </li>
                  <li>
                    <img src={tellIcon} alt='tellIcon' />
                    +968 9938 3841
                  </li>
                  <li>
                    <img src={emailIcon} alt='emailIcon' />
                    info@globalenergyinvestmentco.com
                  </li>
                  <li>
                    <img src={arrowIcon} alt='arrowIcon' />
                    other branch
                  </li>
                </ul>
              </SwiperSlide>
              <SwiperSlide>
              <ul className='contactDetail'>
                  <li className='address'>
                    <img src={locationIcon} alt='locationIcon' />
                    Alb-Schweizer Zer 2, 24119 Kronshagen, Germany. EU
                  </li>
                  <li>
                    <img src={tellIcon} alt='tellIcon' />
                    +49 173 752 6968
                  </li>
                  <li>
                    <img src={emailIcon} alt='emailIcon' />
                    info@globalenergyinvestmentco.com
                  </li>
                  <li>
                    <img src={arrowIcon} alt='arrowIcon' />
                    other branch
                  </li>
                </ul>
              </SwiperSlide>
            </Swiper>
          </div>
          <div className='menu socialMedia'>
            <div className='title'>
              Social Media
            </div>
            <ul>
              <li>
                Instagram:
                <Link to='https://instagram.com/vigor.global.energy.co'>
                  <img src={instagram} alt='instagram' />
                </Link>
              </li>
              <li>
                Telegram :
                <Link to='https://t.me/+96899434964'>
                  <img src={telegram} alt='telegram' />
                </Link>
              </li>
              <li>
                Whatsapp:
                <Link to='https://wa.me/message/4XI6EUJLVACGI1'>
                  <img src={whatsapp} alt='whatsapp' />
                </Link>
              </li>
              <li>
                Twitter:
                <Link to='https://x.com/VGE1885239?t=5uwsUQpcVI6CjWW_GXhD5A&s=08'>
                  <img src={twitter} alt='twitter' />
                </Link>
              </li>
              <li>
                Facebook:
                <Link to='https://www.facebook.com/profile.php?id=61552308902807&mibextid=ZbWKwL'>
                  <img src={facebook} alt='facebook' />
                </Link>
              </li>
            </ul>
          </div>
          <div className='menu newsletter'>
            <div className='text'>
              You can register to our e-mail list to be informed about our
              announcements
            </div>
            <div className='input'>
              <input type='text' name='' id='' placeholder='Email Address' onChange={e => setEmail(e.target.value)} />
              <button onClick={emailHandler}>Send</button>
            </div>
            <div className="partner">
              <div className="logoes">
                <Link to='https://vigorglobalenergy.com/' target='_blank'>
                  <img src={vigorLogo} alt="vigorLogo" />
                </Link>
                <Link to='https://globalenergyinvestmentco.com/' target='_blank'>
                  <img src={energyLogo} alt="energyLogo" />
                </Link>
              </div>
              <button>
                Partner <br />
                company
              </button>
            </div>
          </div>
        </div>
        <div className="copyright">
          All Rights Reserved ©   <Link to='https://ham-team.ir'>Design and Develop : Ham-team.ir</Link>
        </div>
      </div>
    </>
  )
}
